import { CappedDevicesReportComponent } from './capped-devices-report/capped-devices-report.component';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReportsRoutingModule } from './reports-routing.module';
import { ReportsComponent } from './reports/reports.component';
import { CardTableModule } from 'libs/portal/src/modules/tools/card-table/card-table.module';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { MatTabsModule } from '@angular/material/tabs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FiltersModule } from '../tools/filters/filters.module';
import { DeviceUsageIntervalReportComponent } from './device-usage-interval-report/device-usage-interval-report.component';
import { DeviceUsageReportComponent } from './device-usage-report/device-usage-report.component';
import { InventoryReportComponent } from './inventory-report/inventory-report.component';
import { KeepAliveActivityReportComponent } from './keep-alive-activity-report/keep-alive-activity-report.component';
import { ReportDetailsComponent } from './report-details/report-details.component';
import { SimUsageReportComponent } from './sim-usage-report/sim-usage-report.component';
import { DeviceUsageApnReportComponent } from './device-usage-apn-report/device-usage-apn-report.component';
import { KeepAliveEventReportComponent } from './keep-alive-event-report/keep-alive-event-report.component';
import { KeepAliveDeviceStateReportComponent } from './keep-alive-device-state-report/keep-alive-device-state-report.component';
import { RelayApnReportComponent } from './relay-apn-report/relay-apn-report.component';
import { RelayBillingReportComponent } from './relay-billing-report/relay-billing-report.component';
import { RelayIpReportComponent } from './relay-ip-report/relay-ip-report.component';
import { RelayRawReportComponent } from './relay-raw-report/relay-raw-report.component';
import { MatRowComponent } from '../tools/mat-row/mat-row.component';
import { MatColComponent } from '../tools/mat-col/mat-col.component';
import { KeepAliveTLSRawReportComponent } from './keep-alive-tls-raw-report/keep-alive-tls-raw-report.component';
import { KeepAliveTLSDeviceReportComponent } from './keep-alive-tls-device-report/keep-alive-tls-device-report.component';
import { RadiusSimReportComponent } from './radius-sim-report/radius-sim-report.component';
import { AuditCappingReportComponent } from './audit-capping-report/audit-capping-report.component';
import { SimLatestLocationReportComponent } from './sim-latest-location-report/sim-latest-location-report.component';
import { ImeiReportComponent } from './imei-report/imei-report.component';

@NgModule({
  declarations: [
    ReportsComponent,
    ReportDetailsComponent,
    DeviceUsageReportComponent,
    SimUsageReportComponent,
    InventoryReportComponent,
    DeviceUsageIntervalReportComponent,
    KeepAliveActivityReportComponent,
    DeviceUsageApnReportComponent,
    KeepAliveEventReportComponent,
    KeepAliveDeviceStateReportComponent,
    RelayApnReportComponent,
    RelayBillingReportComponent,
    RelayIpReportComponent,
    RelayRawReportComponent,
    KeepAliveTLSRawReportComponent,
    KeepAliveTLSDeviceReportComponent,
    RadiusSimReportComponent,
    CappedDevicesReportComponent,
    AuditCappingReportComponent,
    SimLatestLocationReportComponent,
    ImeiReportComponent,
  ],
  imports: [
    CommonModule,
    CardTableModule,
    ReportsRoutingModule,
    MaterialModule,
    MatTabsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatCheckboxModule,
    CardTableModule,
    FiltersModule,
    MatInputModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatIconModule,
    MatRowComponent,
    MatColComponent,
  ],
  providers: [DatePipe],
})
export class ReportsModule { }
